/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Export_Hours_LabelInputs */

const en_subtitle_export_hours_label = /** @type {(inputs: Subtitle_Export_Hours_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hours`)
};

const fr_subtitle_export_hours_label = /** @type {(inputs: Subtitle_Export_Hours_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Heures`)
};

const de_subtitle_export_hours_label = /** @type {(inputs: Subtitle_Export_Hours_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Std`)
};

const it_subtitle_export_hours_label = /** @type {(inputs: Subtitle_Export_Hours_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ore`)
};

const ru_subtitle_export_hours_label = /** @type {(inputs: Subtitle_Export_Hours_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Часы`)
};

const es_subtitle_export_hours_label = /** @type {(inputs: Subtitle_Export_Hours_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Horas`)
};

const zh_cn2_subtitle_export_hours_label = /** @type {(inputs: Subtitle_Export_Hours_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`小时`)
};

const ja_subtitle_export_hours_label = /** @type {(inputs: Subtitle_Export_Hours_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`営業時間`)
};

const hi_subtitle_export_hours_label = /** @type {(inputs: Subtitle_Export_Hours_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`घंटे`)
};

const pt_pt2_subtitle_export_hours_label = /** @type {(inputs: Subtitle_Export_Hours_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Horas`)
};

/**
* | output |
* | --- |
* | "Hours" |
*
* @param {Subtitle_Export_Hours_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_export_hours_label = /** @type {((inputs?: Subtitle_Export_Hours_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Export_Hours_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_subtitle_export_hours_label(inputs)
	if (locale === "de") return de_subtitle_export_hours_label(inputs)
	if (locale === "it") return it_subtitle_export_hours_label(inputs)
	if (locale === "ru") return ru_subtitle_export_hours_label(inputs)
	if (locale === "es") return es_subtitle_export_hours_label(inputs)
	if (locale === "zh-CN") return zh_cn2_subtitle_export_hours_label(inputs)
	if (locale === "ja") return ja_subtitle_export_hours_label(inputs)
	if (locale === "hi") return hi_subtitle_export_hours_label(inputs)
	if (locale === "pt-PT") return pt_pt2_subtitle_export_hours_label(inputs)
	return en_subtitle_export_hours_label(inputs)
});